import { ArrowLeft } from 'lucide-react'
import type { ReactNode } from 'react'
import { Link, type To } from 'react-router'
import { cn } from '@/lib/utils'

/**
 * "← Terug naar …" (spec-64, U-086): a white pill with ink text that names its
 * destination. It sits on the orange gradient above a page, where plain white
 * text dropped to 1.8–2.5:1; ink on white is 16:1. One component for every back
 * link, so the next change lands everywhere at once.
 */
export function BackLink({
  to,
  children,
  className,
}: {
  to: To
  children: ReactNode
  className?: string
}) {
  return (
    <Link
      to={to}
      className={cn(
        'inline-flex h-8 w-fit items-center gap-1.5 rounded-full bg-card px-3.5 text-sm font-semibold text-foreground shadow-(--shadow-card) transition-colors hover:bg-muted max-md:min-h-11',
        className,
      )}
    >
      <ArrowLeft aria-hidden className="size-4" />
      {children}
    </Link>
  )
}
